import React, { createContext, useContext, useState, useCallback } from "react";

const I18nContext = createContext(null);

const dict = {
  fr: {
    brand: "CORP-FILTER.EXE",
    nav_login: "SE CONNECTER",
    nav_logout: "SE DÉCONNECTER",
    hero_eyebrow: "// MODULE 01 — TRADUCTION CORPORATE",
    hero_title_1: "NE TE FAIS PAS VIRER",
    hero_title_2: "POUR CE QUE TU PENSES",
    hero_title_3: "VRAIMENT.",
    hero_subtitle:
      "Transforme tes messages Teams énervés et tes mails insultants en pure synergie corporate. Diplomatique. Passif-agressif. Ou tellement jargon qu'ils n'oseront jamais le dire à voix haute.",
    hero_cta: "COMMENCER À TRADUIRE",
    hero_disclaimer: "Authentification Google requise. Aucun message n'est enregistré.",
    feature_1_title: "4 NIVEAUX DE TON",
    feature_1_body: "Diplomate, Standard, Passif-Agressif Élégant, Très Corporate.",
    feature_2_title: "3 FORMATS",
    feature_2_body: "Email, Microsoft Teams, Slack. Adapté à chaque canal.",
    feature_3_title: "TRILINGUE FR / EN / NL",
    feature_3_body: "Génère la version polie dans la langue que tu choisis.",
    panel_raw: "ENTRÉE BRUTE",
    panel_raw_hint: "Colle ici ce que tu PENSES vraiment écrire :",
    placeholder_raw:
      "Ex : 'Tu m'envoies encore une réunion à 18h vendredi ? Sérieux, t'as un cerveau ou pas ?'",
    panel_output: "ACTIF CORPORATE",
    panel_output_empty: "Le message poli apparaîtra ici. Prêt à copier-coller.",
    label_level: "NIVEAU DE TON",
    label_format: "FORMAT DE SORTIE",
    label_language: "LANGUE DE SORTIE",
    level_diplomate: "Diplomate",
    level_standard: "Standard Corporate",
    level_passive: "Passif-Agressif Élégant",
    level_very: "Très Corporate (Jargon)",
    format_email: "Email",
    format_teams: "Microsoft Teams",
    format_slack: "Slack",
    lang_fr: "Français",
    lang_en: "English",
    lang_nl: "Nederlands",
    btn_translate: "TRADUIRE",
    btn_copy: "COPIER",
    btn_copied: "COPIÉ !",
    loading_1: "SYNERGISATION...",
    loading_2: "ALIGNEMENT DES PARADIGMES...",
    loading_3: "ON REVIENT VERS VOUS...",
    loading_4: "DEEP DIVE EN COURS...",
    err_empty: "Écris d'abord ce que tu penses vraiment.",
    err_generic: "Quelque chose a explosé. Réessaie.",
    footer_note:
      "Disclaimer : utilisez ce service avec discernement. Vous restez responsable de vos communications.",
    logout_confirm: "Déconnexion réussie.",
    copied_toast: "Texte copié dans le presse-papiers.",
    presets_title: "MES PRESETS",
    presets_hint: "Sauvegarde tes combinaisons ton + format + langue.",
    presets_save: "SAUVEGARDER LE RÉGLAGE ACTUEL",
    presets_name_placeholder: "Nom du preset (ex: Réponse Manager)",
    presets_empty: "Aucun preset enregistré.",
    presets_apply: "APPLIQUER",
    presets_delete: "SUPPRIMER",
    presets_saved: "Preset enregistré.",
    presets_deleted: "Preset supprimé.",
    presets_applied: "Preset appliqué.",
    presets_name_required: "Donne un nom à ton preset.",
    qr_title: "SCANNE POUR PAYER",
    qr_subtitle: "Scanne ce QR code avec ton smartphone pour finaliser le paiement Stripe sur ton téléphone.",
    qr_continue_device: "PAYER SUR CET APPAREIL",
    qr_close: "FERMER",
    qr_loading: "GÉNÉRATION DU QR CODE...",
    counter_label: "SILENCES CORPORATE GÉNÉRÉS À CE JOUR",
    quota_remaining: "TRADUCTIONS RESTANTES",
    quota_unlimited: "ILLIMITÉ",
    quota_resets: "Réinit. le",
    upgrade_cta: "PASSER PRO — 9,99 €/AN",
    upgrade_subtitle: "100 traductions/an. Ou Business : 500/an.",
    plan_business_title: "BUSINESS — 19,99 €/AN",
    plan_business_sub: "500 traductions / an",
    plan_pro_title: "PRO — 9,99 €/AN",
    plan_pro_sub: "100 traductions / an",
    plan_free_sub: "10 traductions à vie",
    founder_badge: "FONDATEUR",
    founder_offer: "OFFRE FONDATEUR — {remaining} places restantes à -{pct}% à vie",
    founder_applied: "Réduction fondateur -{pct}% appliquée à vie 🎉",
    founder_you_are: "Tu es un MEMBRE FONDATEUR — -{pct}% à vie sur tes renouvellements",
    founder_lifetime_tag: "à vie",
    founder_price_label: "PRIX FONDATEUR",
    plan_pick: "CHOISIR",
    referral_title: "PARRAINAGE",
    referral_subtitle: "Invite des collègues. Chaque parrainage payant = +50 traductions offertes.",
    referral_locked: "Réservé aux abonnés Pro ou Business. Passe en payant pour débloquer ton lien.",
    referral_your_link: "TON LIEN",
    referral_copy: "COPIER LE LIEN",
    referral_invited: "PARRAINÉS",
    referral_rewarded: "PAYANTS",
    referral_cap_label: "PLAFOND",
    referral_bonus_received: "🎁 +5 traductions offertes via parrainage !",
    pro_badge: "PRO",
    pro_until: "ACTIF JUSQU'AU",
    blocked_title: "COMPTE BLOQUÉ",
    blocked_body: "Votre compte est temporairement suspendu. Contactez un administrateur.",
    err_quota: "Quota épuisé. Passe à un forfait supérieur pour plus de traductions.",
    pay_success_title: "PAIEMENT REÇU",
    pay_success_body: "Ton forfait est activé. Profite de tes traductions pour l'année à venir.",
    pay_pending: "Traitement du paiement...",
    pay_error: "Le paiement a échoué. Aucun débit n'a été effectué.",
    back_to_app: "RETOUR À LA CONSOLE",
    admin_title: "ADMIN — UTILISATEURS",
    admin_search: "Filtrer par email",
    admin_col_email: "EMAIL",
    admin_col_plan: "PLAN",
    admin_col_status: "STATUT",
    admin_col_created: "CRÉÉ",
    admin_col_actions: "ACTIONS",
    admin_make_pro: "→ PRO 30J",
    admin_make_free: "→ FREE",
    admin_block: "BLOQUER",
    admin_unblock: "DÉBLOQUER",
    admin_reset_quota: "RESET QUOTA",
    admin_blocked: "BLOQUÉ",
    admin_active: "ACTIF",
    nav_admin: "ADMIN",
    nav_billing: "PRO",
    footer_legal_cgu: "CGU",
    footer_legal_privacy: "Confidentialité",
    footer_legal_mentions: "Mentions légales",
    legal_back: "Retour à l'accueil",
    consent_title: "Avant de continuer",
    consent_body:
      "L'accès à CORP-FILTER.EXE se fait via Google. Pour créer votre compte, vous devez accepter nos conditions.",
    consent_checkbox_pre: "J'accepte les",
    consent_and: "et la",
    consent_continue: "Continuer avec Google",
    consent_cancel: "Annuler",
  },
  en: {
    brand: "CORP-FILTER.EXE",
    nav_login: "SIGN IN",
    nav_logout: "SIGN OUT",
    hero_eyebrow: "// MODULE 01 — CORPORATE TRANSLATION",
    hero_title_1: "DON'T GET FIRED",
    hero_title_2: "FOR WHAT YOU",
    hero_title_3: "REALLY THINK.",
    hero_subtitle:
      "Turn your angry Teams replies and insulting emails into pure corporate synergy. Diplomatic. Passive-aggressive. Or so jargon-heavy they will never say it out loud.",
    hero_cta: "START TRANSLATING",
    hero_disclaimer: "Google sign-in required. No messages are stored.",
    feature_1_title: "4 TONE LEVELS",
    feature_1_body: "Diplomatic, Standard, Elegant Passive-Aggressive, Very Corporate.",
    feature_2_title: "3 FORMATS",
    feature_2_body: "Email, Microsoft Teams, Slack. Tailored per channel.",
    feature_3_title: "TRILINGUAL FR / EN / NL",
    feature_3_body: "Get the polite version in the language you pick.",
    panel_raw: "RAW INPUT",
    panel_raw_hint: "Paste here what you actually want to say:",
    placeholder_raw:
      "e.g. 'Another meeting at 6pm on Friday? Seriously, do you even have a brain?'",
    panel_output: "CORPORATE ASSET",
    panel_output_empty: "Your polished message will appear here. Ready to copy.",
    label_level: "TONE LEVEL",
    label_format: "OUTPUT FORMAT",
    label_language: "OUTPUT LANGUAGE",
    level_diplomate: "Diplomatic",
    level_standard: "Standard Corporate",
    level_passive: "Elegant Passive-Aggressive",
    level_very: "Very Corporate (Jargon)",
    format_email: "Email",
    format_teams: "Microsoft Teams",
    format_slack: "Slack",
    lang_fr: "Français",
    lang_en: "English",
    lang_nl: "Nederlands",
    btn_translate: "TRANSLATE",
    btn_copy: "COPY",
    btn_copied: "COPIED!",
    loading_1: "SYNERGIZING...",
    loading_2: "ALIGNING PARADIGMS...",
    loading_3: "CIRCLING BACK...",
    loading_4: "DEEP DIVING...",
    err_empty: "Write what you really think first.",
    err_generic: "Something exploded. Try again.",
    footer_note:
      "Disclaimer: use this service with discernment. You remain responsible for your communications.",
    logout_confirm: "Successfully signed out.",
    copied_toast: "Text copied to clipboard.",
    presets_title: "MY PRESETS",
    presets_hint: "Save your tone + format + language combos.",
    presets_save: "SAVE CURRENT SETTINGS",
    presets_name_placeholder: "Preset name (e.g. Manager Reply)",
    presets_empty: "No saved presets.",
    presets_apply: "APPLY",
    presets_delete: "DELETE",
    presets_saved: "Preset saved.",
    presets_deleted: "Preset deleted.",
    presets_applied: "Preset applied.",
    presets_name_required: "Give your preset a name.",
    qr_title: "SCAN TO PAY",
    qr_subtitle: "Scan this QR code with your smartphone to complete the Stripe payment on your phone.",
    qr_continue_device: "PAY ON THIS DEVICE",
    qr_close: "CLOSE",
    qr_loading: "GENERATING QR CODE...",
    counter_label: "CORPORATE SILENCES GENERATED TO DATE",
    quota_remaining: "TRANSLATIONS LEFT",
    quota_unlimited: "UNLIMITED",
    quota_resets: "Resets",
    upgrade_cta: "GO PRO — €9.99/YR",
    upgrade_subtitle: "100 translations/year. Or Business: 500/year.",
    plan_business_title: "BUSINESS — €19.99/YR",
    plan_business_sub: "500 translations / year",
    plan_pro_title: "PRO — €9.99/YR",
    plan_pro_sub: "100 translations / year",
    plan_free_sub: "10 translations for life",
    founder_badge: "FOUNDER",
    founder_offer: "FOUNDER OFFER — {remaining} seats left at -{pct}% for life",
    founder_applied: "Founder discount -{pct}% applied for life 🎉",
    founder_you_are: "You are a FOUNDING MEMBER — -{pct}% for life on renewals",
    founder_lifetime_tag: "for life",
    founder_price_label: "FOUNDER PRICE",
    plan_pick: "PICK",
    referral_title: "REFERRALS",
    referral_subtitle: "Invite colleagues. Each paid referral = +50 free translations.",
    referral_locked: "Pro / Business subscribers only. Upgrade to unlock your link.",
    referral_your_link: "YOUR LINK",
    referral_copy: "COPY LINK",
    referral_invited: "INVITED",
    referral_rewarded: "PAID",
    referral_cap_label: "CAP",
    referral_bonus_received: "🎁 +5 free translations via referral!",
    pro_badge: "PRO",
    pro_until: "ACTIVE UNTIL",
    blocked_title: "ACCOUNT BLOCKED",
    blocked_body: "Your account is temporarily suspended. Contact an administrator.",
    err_quota: "Quota exhausted. Upgrade your plan for more translations.",
    pay_success_title: "PAYMENT RECEIVED",
    pay_success_body: "Your plan is active. Enjoy your translations for the year ahead.",
    pay_pending: "Processing payment...",
    pay_error: "Payment failed. No charge was made.",
    back_to_app: "BACK TO CONSOLE",
    admin_title: "ADMIN — USERS",
    admin_search: "Filter by email",
    admin_col_email: "EMAIL",
    admin_col_plan: "PLAN",
    admin_col_status: "STATUS",
    admin_col_created: "CREATED",
    admin_col_actions: "ACTIONS",
    admin_make_pro: "→ PRO 30D",
    admin_make_free: "→ FREE",
    admin_block: "BLOCK",
    admin_unblock: "UNBLOCK",
    admin_reset_quota: "RESET QUOTA",
    admin_blocked: "BLOCKED",
    admin_active: "ACTIVE",
    nav_admin: "ADMIN",
    nav_billing: "PRO",
    footer_legal_cgu: "Terms",
    footer_legal_privacy: "Privacy",
    footer_legal_mentions: "Legal notice",
    legal_back: "Back to home",
    consent_title: "Before you continue",
    consent_body:
      "Access to CORP-FILTER.EXE is via Google. To create your account, you must accept our terms.",
    consent_checkbox_pre: "I accept the",
    consent_and: "and the",
    consent_continue: "Continue with Google",
    consent_cancel: "Cancel",
  },
  nl: {
    brand: "CORP-FILTER.EXE",
    nav_login: "INLOGGEN",
    nav_logout: "UITLOGGEN",
    hero_eyebrow: "// MODULE 01 — ZAKELIJKE VERTALING",
    hero_title_1: "WORD NIET ONTSLAGEN",
    hero_title_2: "OM WAT JE ECHT",
    hero_title_3: "DENKT.",
    hero_subtitle:
      "Zet je boze Teams-berichten en beledigende mails om in pure zakelijke synergie. Diplomatiek. Passief-agressief. Of zo vol jargon dat ze het nooit hardop durven zeggen.",
    hero_cta: "BEGIN MET VERTALEN",
    hero_disclaimer: "Google-aanmelding vereist. Er worden geen berichten opgeslagen.",
    feature_1_title: "4 TOONNIVEAUS",
    feature_1_body: "Diplomatiek, Standaard, Elegant Passief-Agressief, Zeer Zakelijk.",
    feature_2_title: "3 FORMATEN",
    feature_2_body: "E-mail, Microsoft Teams, Slack. Afgestemd per kanaal.",
    feature_3_title: "DRIETALIG FR / EN / NL",
    feature_3_body: "Krijg de beleefde versie in de taal die je kiest.",
    panel_raw: "RUWE INVOER",
    panel_raw_hint: "Plak hier wat je echt wilt zeggen:",
    placeholder_raw:
      "bv. 'Alweer een vergadering om 18u op vrijdag? Serieus, heb je wel hersens?'",
    panel_output: "ZAKELIJK ACTIEF",
    panel_output_empty: "Je gepolijste bericht verschijnt hier. Klaar om te kopiëren.",
    label_level: "TOONNIVEAU",
    label_format: "UITVOERFORMAAT",
    label_language: "UITVOERTAAL",
    level_diplomate: "Diplomatiek",
    level_standard: "Standaard Zakelijk",
    level_passive: "Elegant Passief-Agressief",
    level_very: "Zeer Zakelijk (Jargon)",
    format_email: "E-mail",
    format_teams: "Microsoft Teams",
    format_slack: "Slack",
    lang_fr: "Français",
    lang_en: "English",
    lang_nl: "Nederlands",
    btn_translate: "VERTALEN",
    btn_copy: "KOPIËREN",
    btn_copied: "GEKOPIEERD!",
    loading_1: "SYNERGIE CREËREN...",
    loading_2: "PARADIGMA'S AFSTEMMEN...",
    loading_3: "WE KOMEN EROP TERUG...",
    loading_4: "DEEP DIVE BEZIG...",
    err_empty: "Schrijf eerst wat je echt denkt.",
    err_generic: "Er is iets ontploft. Probeer opnieuw.",
    footer_note:
      "Disclaimer: gebruik deze dienst met onderscheidingsvermogen. Je blijft verantwoordelijk voor je communicatie.",
    logout_confirm: "Succesvol uitgelogd.",
    copied_toast: "Tekst gekopieerd naar klembord.",
    presets_title: "MIJN PRESETS",
    presets_hint: "Bewaar je toon + formaat + taal-combinaties.",
    presets_save: "HUIDIGE INSTELLING OPSLAAN",
    presets_name_placeholder: "Presetnaam (bv. Antwoord Manager)",
    presets_empty: "Geen opgeslagen presets.",
    presets_apply: "TOEPASSEN",
    presets_delete: "VERWIJDEREN",
    presets_saved: "Preset opgeslagen.",
    presets_deleted: "Preset verwijderd.",
    presets_applied: "Preset toegepast.",
    presets_name_required: "Geef je preset een naam.",
    qr_title: "SCAN OM TE BETALEN",
    qr_subtitle: "Scan deze QR-code met je smartphone om de Stripe-betaling op je telefoon af te ronden.",
    qr_continue_device: "BETALEN OP DIT APPARAAT",
    qr_close: "SLUITEN",
    qr_loading: "QR-CODE GENEREREN...",
    counter_label: "CORPORATE STILTES TOT NU TOE GEGENEREERD",
    quota_remaining: "VERTALINGEN OVER",
    quota_unlimited: "ONBEPERKT",
    quota_resets: "Reset op",
    upgrade_cta: "GA PRO — € 9,99/JR",
    upgrade_subtitle: "100 vertalingen/jaar. Of Business: 500/jaar.",
    plan_business_title: "BUSINESS — € 19,99/JR",
    plan_business_sub: "500 vertalingen / jaar",
    plan_pro_title: "PRO — € 9,99/JR",
    plan_pro_sub: "100 vertalingen / jaar",
    plan_free_sub: "10 vertalingen voor het leven",
    founder_badge: "OPRICHTER",
    founder_offer: "OPRICHTERSAANBOD — {remaining} plaatsen over tegen -{pct}% voor het leven",
    founder_applied: "Oprichterskorting -{pct}% toegepast voor het leven 🎉",
    founder_you_are: "Je bent een OPRICHTEND LID — -{pct}% voor het leven bij verlengingen",
    founder_lifetime_tag: "voor het leven",
    founder_price_label: "OPRICHTERSPRIJS",
    plan_pick: "KIEZEN",
    referral_title: "DOORVERWIJZING",
    referral_subtitle: "Nodig collega's uit. Elke betalende doorverwijzing = +50 gratis vertalingen.",
    referral_locked: "Alleen voor Pro- of Business-abonnees. Upgrade om je link te ontgrendelen.",
    referral_your_link: "JOUW LINK",
    referral_copy: "LINK KOPIËREN",
    referral_invited: "UITGENODIGD",
    referral_rewarded: "BETALEND",
    referral_cap_label: "LIMIET",
    referral_bonus_received: "🎁 +5 gratis vertalingen via doorverwijzing!",
    pro_badge: "PRO",
    pro_until: "ACTIEF TOT",
    blocked_title: "ACCOUNT GEBLOKKEERD",
    blocked_body: "Je account is tijdelijk geschorst. Neem contact op met een beheerder.",
    err_quota: "Quotum op. Upgrade je abonnement voor meer vertalingen.",
    pay_success_title: "BETALING ONTVANGEN",
    pay_success_body: "Je abonnement is actief. Geniet van je vertalingen voor het komende jaar.",
    pay_pending: "Betaling verwerken...",
    pay_error: "Betaling mislukt. Er is niets afgeschreven.",
    back_to_app: "TERUG NAAR CONSOLE",
    admin_title: "ADMIN — GEBRUIKERS",
    admin_search: "Filter op e-mail",
    admin_col_email: "E-MAIL",
    admin_col_plan: "PLAN",
    admin_col_status: "STATUS",
    admin_col_created: "AANGEMAAKT",
    admin_col_actions: "ACTIES",
    admin_make_pro: "→ PRO 30D",
    admin_make_free: "→ GRATIS",
    admin_block: "BLOKKEREN",
    admin_unblock: "DEBLOKKEREN",
    admin_reset_quota: "QUOTUM RESETTEN",
    admin_blocked: "GEBLOKKEERD",
    admin_active: "ACTIEF",
    nav_admin: "ADMIN",
    nav_billing: "PRO",
    footer_legal_cgu: "Voorwaarden",
    footer_legal_privacy: "Privacy",
    footer_legal_mentions: "Wettelijke vermeldingen",
    legal_back: "Terug naar startpagina",
    consent_title: "Voordat je verdergaat",
    consent_body:
      "Toegang tot CORP-FILTER.EXE verloopt via Google. Om je account aan te maken, moet je onze voorwaarden accepteren.",
    consent_checkbox_pre: "Ik accepteer de",
    consent_and: "en het",
    consent_continue: "Doorgaan met Google",
    consent_cancel: "Annuleren",
  },
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return window.localStorage.getItem("ui_lang") || "fr";
  });

  const t = useCallback((key, params) => {
    let s = dict[lang][key] ?? key;
    if (params) {
      for (const k of Object.keys(params)) {
        s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(params[k]));
      }
    }
    return s;
  }, [lang]);

  const setLanguage = (l) => {
    setLang(l);
    if (typeof window !== "undefined") window.localStorage.setItem("ui_lang", l);
  };

  return (
    <I18nContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
